import React, { useState } from 'react';

import styled from 'styled-components';
import { AlertActionElem } from '../../common/alert-action';

import { GridElem } from '../../common/grid';
import { Card } from './frame/card';
import { EmptyListElem } from '../../common/empty-list-elem';
import { COLOR_ENUM } from '../../theme/color';
import { SkeletonDataElem } from '../../common/skeleton-data';
import { Spacing } from '../../theme';
import { PaginationElem } from '../../common/pagination';
import { POPUP_ITEM_DATA_INTER } from './constant';

export const Component: React.FC<{
  list?: POPUP_ITEM_DATA_INTER[];
  isLoading?: boolean;
  isSuccess?: boolean;
  isError?: boolean;
  errorMessage?: string;
  count?: number;
  onChangePage: (arg: number) => void;
  page: number;
  pageSize: number;
  pageCount: number;
}> = ({
  list,
  isLoading,
  isSuccess,
  isError,
  errorMessage,
  page,
  onChangePage,
  pageSize,
  pageCount,
}) => {
  const isEmpty = list && list.length < 1;

  const [openCardId, setOpenCardId] = useState<string | null>(null);

  const handleCardClick = (id: string) => {
    setOpenCardId((prevOpenCardId) => (prevOpenCardId === id ? null : id));
  };

  return (
    <GridElemStyled spacing={6}>
      <GridStyled>
        {isLoading && <SkeletonDataElem />}
        {isError && <AlertActionElem tid={`ERROR.${errorMessage}`} />}
        {isEmpty && !isLoading && (
          <EmptyListElem
            titleTid="EVENT.LIST.IS_EMPTY_TITLE"
            descriptionTid="EVENT.LIST.IS_EMPTY_DESCRIPTION"
          />
        )}
        {!isLoading && <Divider />}
        {isSuccess &&
          list &&
          !isEmpty &&
          list.map((item: POPUP_ITEM_DATA_INTER) => (
            <>
              <React.Fragment key={item.id}>
                <Card
                  isOpen={openCardId === item.id}
                  onClick={() => handleCardClick(item.id)}
                  data={item}
                />
              </React.Fragment>
              <Divider />
            </>
          ))}
      </GridStyled>

      {!isEmpty && (
        <PaginationStyled
          pageSize={pageSize}
          defaultPageSize={pageSize}
          current={page}
          onChange={onChangePage}
          total={pageCount}
        />
      )}
    </GridElemStyled>
  );
};

const Divider = styled.div`
  background-color: ${({ theme }) => theme[COLOR_ENUM.DIVIDER]};
  height: 1px;
  width: 100%;
`;

const PaginationStyled = styled(PaginationElem)`
  position: absolute;
  bottom: ${Spacing(33)};
  left: 50%;
  transform: translateX(-50%);
`;

const GridElemStyled = styled(GridElem)`
  margin-top: ${Spacing(1)};
  margin-bottom: ${Spacing(22)};
`;

const GridStyled = styled(GridElem)`
  grid-auto-columns: auto max-content max-content;
  row-gap: ${Spacing(4)};
`;
